import { DateTime } from 'luxon';

export function toMoney (str) {
		return parseFloat(str).toFixed(2).replace('.', ',') + ' €';
}

export function toPercent(amount) {
    return Math.round(amount / 100.0) + ' %';
}

export function toDateAndTime(d) {
    return DateTime.fromISO(d).setLocale('de').toFormat("ccc'.' dd.MM. HH:mm 'Uhr'");
}

export function optimizeImage(url, imageSize=400) {
    return `https://process.filestackapi.com/AZ40T6UWDRnGhMi7AH7kQz/resize=width:${imageSize},height:${imageSize}/output=f:jpg/compress/quality=v:94/${url}`;
}

export function discountCodeHumanized (discountCode) {
    if (!discountCode) {
        return '';
    }

    var label = '';
    if (discountCode.name) {
        label += discountCode.name + ' - ';
    }

    if (discountCode.type == 'absolute') {
        label += discountCode.amount.toFixed(2).replace('.', ',') + ' €';
    } else {
        label += parseInt(discountCode.amount) + ' %';
    }

    return label;
}
